import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { AuthProvider } from '@/components/common/AuthProvider';
import { isPortalSubdomain, isCustomDomain } from '@/utils/portalDetection';
import { initVarioIframeHeight } from '@/services/varioMessage';

const basePath = (isPortalSubdomain() || isCustomDomain()) ? '/' : (import.meta.env.VITE_BASE_PATH || '/');

function App() {
  useEffect(() => {
    // Vario-Embedding: laeuft die App im iframe, muss sie ihre Hoehe an den
    // Vario-Parent melden - sonst bleibt der iframe auf Hoehe 0 (leeres Panel).
    if (window.self !== window.top) {
      initVarioIframeHeight();
    }
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter basename={basePath} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
